import { ESTUDIO_JOTA } from '@App/libs/utils/constants/global'

const staticFooterMenu = [
    {
        columnTitle: 'PRO Poder',
        columnItens: [
            {
                title: 'Apostas da Semana',
                url: '/poder/apostas-da-semana',
                openInNewTab: false
            },
            {
                title: 'Impacto nas Instituições',
                url: '/poder/impacto-nas-instituicoes',
                openInNewTab: false
            },
            {
                title: 'Risco Político',
                url: '/poder/risco-politico',
                openInNewTab: false
            },
            {
                title: 'Alertas',
                url: '/poder/alertas',
                openInNewTab: false
            }
        ]
    },
    {
        columnTitle: 'PRO Tributos',
        columnItens: [
            {
                title: 'Apostas da Semana',
                url: '/tributos/apostas-da-semana',
                openInNewTab: false
            },
            {
                title: 'Direto do CARF',
                url: '/tributos/direto-do-carf',
                openInNewTab: false
            },
            {
                title: 'Direto da Corte',
                url: '/tributos/direto-da-corte',
                openInNewTab: false
            },
            {
                title: 'Direto do Legislativo',
                url: '/tributos/direto-do-legislativo',
                openInNewTab: false
            },
            {
                title: 'Matinal',
                url: '/tributos/matinal',
                openInNewTab: false
            },
            {
                title: 'Relatórios Especiais',
                url: '/tributos/relatorio-especial',
                openInNewTab: false
            }
        ]
    },
    {
        columnTitle: 'PRO Trabalhista',
        columnItens: [
            {
                title: 'Apostas da Semana',
                url: '/trabalhista/apostas-da-semana',
                openInNewTab: false
            },
            {
                title: 'Direto da Corte',
                url: '/trabalhista/direto-da-corte',
                openInNewTab: false
            },
            {
                title: 'Direto da Fonte',
                url: '/trabalhista/direto-da-fonte',
                openInNewTab: false
            },
            {
                title: "Giro nos TRT's",
                url: '/trabalhista/giro-nos-trts',
                openInNewTab: false
            },
            {
                title: 'Relatório Especial',
                url: '/trabalhista/relatorio-especial',
                openInNewTab: false
            }
        ]
    },
    {
        columnTitle: 'PRO Saúde',
        columnItens: [
            {
                title: 'Apostas da Semana',
                url: '/saude/apostas-da-semana',
                openInNewTab: false
            },
            {
                title: 'Bastidores da Saúde',
                url: '/saude/bastidores-da-saude',
                openInNewTab: false
            },
            {
                title: 'Direto da Anvisa/ANS',
                url: '/saude/direto-da-anvisa-ans',
                openInNewTab: false
            },
            {
                title: 'Direto da Corte',
                url: '/saude/direto-da-corte',
                openInNewTab: false
            },
            {
                title: 'Direto do Legislativo',
                url: '/saude/direto-do-legislativo',
                openInNewTab: false
            },
            {
                title: 'Matinal',
                url: '/saude/matinal',
                openInNewTab: false
            },
            {
                title: 'Relatório Especial',
                url: '/saude/relatorio-especial',
                openInNewTab: false
            },
            {
                title: 'Alertas',
                url: '/saude/alertas',
                openInNewTab: false
            }
        ]
    },
    {
        columnTitle: 'Editorias',
        columnItens: [
            {
                title: 'Executivo',
                url: '/poder/executivo',
                openInNewTab: false
            },
            {
                title: 'Legislativo',
                url: '/poder/legislativo',
                openInNewTab: false
            },
            {
                title: 'STF',
                url: '/poder/stf',
                openInNewTab: false
            },
            {
                title: 'Justiça',
                url: '/poder/justica',
                openInNewTab: false
            },
            {
                title: 'Energia',
                url: '/energia',
                openInNewTab: false
            },
            {
                title: 'Opinião e Análise',
                url: '/opiniao-e-analise',
                openInNewTab: false
            },
            {
                title: 'Coberturas Especiais',
                url: '/coberturas-especiais',
                openInNewTab: false
            },
            {
                title: 'Direito trabalhista',
                url: '/trabalho',
                openInNewTab: false
            },
            {
                title: 'Eleições 2026',
                url: '/eleicoes',
                openInNewTab: false
            }
        ]
    },
    {
        columnTitle: 'Sobre o JOTA',
        columnItens: [
            {
                title: 'Estúdio JOTA',
                url: ESTUDIO_JOTA,
                openInNewTab: true
            },
            {
                title: 'Ética JOTA',
                url: `${process.env.NEXT_PUBLIC_JOTAINFO}/etica-jota`,
                openInNewTab: true
            },
            {
                title: 'Política de Privacidade',
                url: `${process.env.NEXT_PUBLIC_JOTAINFO}/politica-de-privacidade`,
                openInNewTab: true
            },
            {
                title: 'Política de diversidade',
                url: `${process.env.NEXT_PUBLIC_JOTAINFO}/politica-de-diversidade`,
                openInNewTab: true
            },
            {
                title: 'Seus Dados',
                url: `https://app.dadoslegais.com.br/jota/ `,
                openInNewTab: true
            },
            {
                title: 'Termos de Uso',
                url: `${process.env.NEXT_PUBLIC_JOTAINFO}/termos-de-uso`,
                openInNewTab: true
            },
            {
                title: 'Quem Somos',
                url: `${process.env.NEXT_PUBLIC_JOTAINFO}/quem-somos`,
                openInNewTab: true
            },
            {
                title: 'Blog',
                url: `${process.env.NEXT_PUBLIC_JOTAINFO_FRONT}/blog`,
                openInNewTab: true
            }
        ]
    }
]

export default staticFooterMenu
